import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Divider from './Divider'
import Link from './Link'

const FloatBottom = styled.div`
  margin-top: auto;
`

export default class QuitLink extends Component {
  render() {
    return (
      <Fragment>
        <FloatBottom />
        <Divider />
        <Link color="red" {...this.props} />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/QuitLink.js